import { type Animation, createAnimation } from '@ionic/angular';

interface AnimationOptions {
  enteringEl?: HTMLElement;
  leavingEl?: HTMLElement;
}

export const dissolveAnimation = (baseEl: HTMLElement, opts?: AnimationOptions): Animation => {
  const rootAnimation = createAnimation().duration(500).easing('ease-in-out');

  if (opts?.enteringEl) {
    const enteringContent = opts.enteringEl.querySelector('ion-content');
    const enteringAnimation = createAnimation()
      .addElement(enteringContent || opts.enteringEl)
      .fromTo('opacity', 0, 1)
      .afterStyles({ opacity: 1 });

    rootAnimation.addAnimation(enteringAnimation);
  }

  if (opts?.leavingEl) {
    const leavingContent = opts.leavingEl.querySelector('ion-content');
    const leavingAnimation = createAnimation()
      .addElement(leavingContent || opts.leavingEl)
      .fromTo('opacity', 1, 0)
      .afterClearStyles(['opacity']);

    rootAnimation.addAnimation(leavingAnimation);
  }

  return rootAnimation;
};
